import { type FC, type PropsWithChildren, useCallback, useState } from 'react';
import {
  type ForwardableDocumentProps,
  ForwardDocumentProvider,
} from '@matrix-forge/ui/contexts/ForwardDocumentContext';
import { ForwardDocumentModalContainer } from '@/components/ForwardDocumentModal';

export const ForwardDocumentProviderConnected: FC<PropsWithChildren> = ({ children }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [document, setDocument] = useState<ForwardableDocumentProps | null>(null);
  const onForwardDocument = useCallback(
    ({ document }: { document: ForwardableDocumentProps; agentId: string }) => {
      setDocument(document);
      setIsModalOpen(true);
    },
    []
  );
  return (
    <>
      <ForwardDocumentProvider onForwardDocument={onForwardDocument} children={children} />
      <ForwardDocumentModalContainer
        isOpen={isModalOpen}
        onOpenChange={setIsModalOpen}
        document={document}
      />
    </>
  );
};
